/**
 * AvatarStack - Overlapping avatar stack for showing a group of collaborators
 * Design: Join Trip - Success (tripways.pen node FQe3f, "Members Preview")
 */

import { getAvatarFallback } from '../../hooks/useUserProfiles';
import type { UserProfile } from '../../types/userProfile';

const FALLBACK_COLORS = ['#0dccf2', '#f59e0b', '#8b5cf6', '#10b981', '#ef4444', '#3b82f6'];

function colorForUserId(userId: number): string {
  return FALLBACK_COLORS[userId % FALLBACK_COLORS.length];
}

interface AvatarStackProps {
  profiles: UserProfile[];
  max?: number;
  size?: number;
}

export default function AvatarStack({ profiles, max = 5, size = 32 }: AvatarStackProps) {
  const visible = profiles.slice(0, max);
  const overflow = profiles.length - visible.length;

  return (
    <div className="flex items-center" style={{ gap: -8 }}>
      {visible.map((profile) => (
        <div
          key={profile.userId}
          className="flex items-center justify-center rounded-full border-2 border-white text-white font-semibold overflow-hidden -ml-2 first:ml-0"
          style={{
            width: size,
            height: size,
            fontSize: size * 0.375,
            backgroundColor: colorForUserId(profile.userId),
          }}
        >
          {profile.avatar ? (
            <img src={profile.avatar} alt={profile.nickname} className="w-full h-full object-cover" />
          ) : (
            getAvatarFallback(profile.nickname)
          )}
        </div>
      ))}
      {overflow > 0 && (
        <div
          className="flex items-center justify-center rounded-full border-2 border-white bg-slate-400 text-white font-semibold -ml-2"
          style={{ width: size, height: size, fontSize: size * 0.32 }}
        >
          +{overflow}
        </div>
      )}
    </div>
  );
}
